module.exports = __webpack_public_path__ + "static/media/grayscale-products.b6b7f421.png";